module.exports = __webpack_public_path__ + "img/browse-vehicles-background-ford.d751300d.png";